import { WaitingScreen } from "./lib/WaitingScreen";
/**
 * 画面初期化イベント
 */
addEventListener("load", () => {
  // ログインフォームでsubmitされた時に割り込む
  const form = document.getElementById("form") as HTMLFormElement;
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    login();
  });
});

/**
 * ログイン
 */
const login = () => {
  //フロントエンド側だけでデバッグ中の場合、ログイン処理を行わずメニュー画面に遷移
  if (import.meta.env.MODE === "development") {
    location.href = "./menu.html";
    return;
  }
  WaitingScreen.show("ログイン中...");
  (document.getElementById("form") as HTMLFormElement).submit();
};
